import _ from 'underscore';
import { useCallback, useState, useMemo } from 'react';
import {
  getAssetSourceOptions,
  handleRealUsedFlag,
} from '@bingads-webui-campaign-react/asset-library-model';

export const useAssetSourcesFilter = ({
  logger,
  i18n,
  preference,
  realUsedFlagSuffix,
  disabledAssetSources = [],
}) => {
  const [assetSources, setAssetSources] = useState([]);

  const assetSourceOptions = useMemo(() => {
    const options = getAssetSourceOptions(i18n);
    if (!_.isEmpty(disabledAssetSources)) {
      return options.filter(({ key }) => !disabledAssetSources.includes(key));
    }

    return options;
  }, [disabledAssetSources, i18n]);

  const onAssetSourceFilterChange = useCallback((newAssetSources) => {
    if (!_.isEqual(assetSources, newAssetSources)) {
      setAssetSources(newAssetSources);
      logger.logTrace('onAssetSourceFilterChange', { assetSources: (assetSources || []).join(',') });
      handleRealUsedFlag(preference, realUsedFlagSuffix);
    }
  }, [assetSources, logger, preference, realUsedFlagSuffix]);

  return {
    assetSources,
    assetSourceOptions,
    onAssetSourceFilterChange,
  };
};
